import React from 'react';
import LoginScreen from '@/components/auth/LoginScreen';

const STAFF_BG = 'https://images.pexels.com/photos/37406898/pexels-photo-37406898.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1200';

export default function StaffLogin() {
  return (
    <LoginScreen
      bg={STAFF_BG}
      badge="Accesso Staff"
      heroTitle="Lavora con la Sila."
      heroText="Professionisti e freelance: accedi alla tua area, completa la verifica identità e gestisci i tuoi incarichi sul territorio."
      formTitle="Bentornato in Staff"
      formSubtitle="Accedi alla tua area professionista."
      showOAuth={false}
      register={{ prefix: 'Sei un nuovo professionista?', to: '/staff/registrati', label: 'Registrati come Staff' }}
      testidPrefix="staff-login"
    />
  );
}
